import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { MobileScrollWrapper } from 'components/mobile/MobileScrollWrapper';
import { LandingPageContent } from 'components/site/pages/LandingPageContent';
import CSS from 'csstype';
import { MinuteWhiteBg } from 'pages/minute/shared/MinuteWhiteBg';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { GlobalContext } from 'session/state/context';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const LandingPage = (): JSX.Element => {
    const { state } = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (state.loggedUserChecked && !state.loggedUser) {
            navigate('/create');
        }
    }, [state.loggedUserChecked, state.loggedUser]);

    if (!state.loggedUserChecked) {
        return <></>;
    }

    if (!state.loggedUser) {
        return null;
    }

    return (
        <MobileScrollWrapper>
            <S_LandingPage>
                <S_Center>
                    <MinutePageHeader />
                    <MinutePageTitle
                        title={Localization.WELCOME}
                        subtitle={Localization.WELCOME_DESC}
                    />
                    <S_Row>
                        <S_Mid>
                            <LandingPageContent />
                        </S_Mid>
                    </S_Row>
                </S_Center>
                <MinuteWhiteBg />
            </S_LandingPage>
        </MobileScrollWrapper>
    );
};

const S_LandingPage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
    min-width: 1260px;
    @media only screen and (max-width: 1260px) {
        overflow-x: scroll;
    }
`;

const S_Center = styled.div`
    display: flex;
    width: 1260px;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
`;

const S_Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const S_Mid = styled.div`
    width: 830px;
`;
